import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["data-test"]
const _hoisted_3 = ["data-test"]

import { computed } from 'vue'
import { formattedDate } from 'frontcore/presentation/calendar/domain/helpers'

type Props = {
  dataTest?: string
  label?: string
  placeholder?: string
  value?: Date | null
}
type Emits = (e: 'click', event: Event) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'RangeSelectorSelectedDate',
  props: {
    dataTest: { default: 'calendar-menu-selection' },
    label: {},
    placeholder: {},
    value: { default: null }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const selectedDate = computed((): string => {
  if (props.value == null) { return props.placeholder ?? ''}
  return formattedDate(props.value) ?? ''
})

const labelDataTest = computed(():string => `${props.dataTest}-label`)
const dateDataTest = computed(():string => `${props.dataTest}-date`)
const dateCSSClass = computed((): string => {
  return props.value != null ? 'text-core-primary-10' : 'text-core-neutral-cold-60'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-test": _ctx.dataTest,
    class: "calendar__menu__selection flex flex-column s-p-2 gap-1",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('click', $event)), ["stop"]))
  }, [
    _createElementVNode("span", {
      "data-test": labelDataTest.value,
      class: "body--auxiliary-01-bold text-core-primary-10"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("span", {
      "data-test": dateDataTest.value,
      class: _normalizeClass([dateCSSClass.value, "calendar__menu__selection_date body--auxiliary-01"])
    }, _toDisplayString(selectedDate.value), 11, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})